/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown>, hour: NonNullable<unknown> }} Event_State_Days_LeftInputs */

const en_event_state_days_left = /** @type {(inputs: Event_State_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ends in ${i?.day}d ${i?.hour}h`)
};

const ar_event_state_days_left = /** @type {(inputs: Event_State_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ينتهي خلال ${i?.day} يوم و ${i?.hour} ساعة`)
};

const de_event_state_days_left = /** @type {(inputs: Event_State_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`endet in ${i?.day} T. ${i?.hour} Std.`)
};

const es_event_state_days_left = /** @type {(inputs: Event_State_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`termina en ${i?.day} d ${i?.hour} h`)
};

const fr_event_state_days_left = /** @type {(inputs: Event_State_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`se termine dans ${i?.day} j ${i?.hour} h`)
};

const it_event_state_days_left = /** @type {(inputs: Event_State_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`termina tra ${i?.day} g ${i?.hour} o`)
};

const ja_event_state_days_left = /** @type {(inputs: Event_State_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`あと ${i?.day}日 ${i?.hour}時間で終了`)
};

const ko_event_state_days_left = /** @type {(inputs: Event_State_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}일 ${i?.hour}시간 후 종료`)
};

const pt_br_event_state_days_left = /** @type {(inputs: Event_State_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`termina em ${i?.day} d ${i?.hour} h`)
};

const ru_event_state_days_left = /** @type {(inputs: Event_State_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`закончится через ${i?.day} дн. ${i?.hour} ч.`)
};

const th_event_state_days_left = /** @type {(inputs: Event_State_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`สิ้นสุดในอีก ${i?.day} วัน ${i?.hour} ชม.`)
};

const tr_event_state_days_left = /** @type {(inputs: Event_State_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} g ${i?.hour} sa içinde bitiyor`)
};

const zh_cn_event_state_days_left = /** @type {(inputs: Event_State_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}天 ${i?.hour}小时后结束`)
};

const zh_tw_event_state_days_left = /** @type {(inputs: Event_State_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}天 ${i?.hour}時後結束`)
};

/**
* | output |
* | --- |
* | "ends in {day}d {hour}h" |
*
* @param {Event_State_Days_LeftInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const event_state_days_left = /** @type {((inputs: Event_State_Days_LeftInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_State_Days_LeftInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_state_days_left(inputs)
	if (locale === "ar") return ar_event_state_days_left(inputs)
	if (locale === "de") return de_event_state_days_left(inputs)
	if (locale === "es") return es_event_state_days_left(inputs)
	if (locale === "fr") return fr_event_state_days_left(inputs)
	if (locale === "it") return it_event_state_days_left(inputs)
	if (locale === "ja") return ja_event_state_days_left(inputs)
	if (locale === "ko") return ko_event_state_days_left(inputs)
	if (locale === "pt_br") return pt_br_event_state_days_left(inputs)
	if (locale === "ru") return ru_event_state_days_left(inputs)
	if (locale === "th") return th_event_state_days_left(inputs)
	if (locale === "tr") return tr_event_state_days_left(inputs)
	if (locale === "zh_cn") return zh_cn_event_state_days_left(inputs)
	return zh_tw_event_state_days_left(inputs)
});